export default "__VITE_ASSET__BFi5pPHG__"